









































































import { Component, Prop } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { mdiInformationOutline } from '@mdi/js'
import { VPopover } from 'v-tooltip'
import { IProductBrand } from '~/assets/interfaces/products'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImage from '~/components/images/image.vue'
import MixinGeneral from '~/assets/mixins/general'

@Component({
  components: {
    LazyHydrate,
    VPopover,
    ComponentIcon,
    ComponentImage,
  },
})
export default class ComponentBrand extends MixinGeneral {
  @Prop({ type: Object, default: () => {} }) readonly brand: IProductBrand
  @Prop({ type: String, default: '' }) readonly countryBuildName: string
  @Prop({ type: String, default: '' }) readonly countryBuildImg: string

  private mdiInformationOutline = mdiInformationOutline
}
